import { z } from 'zod'

import { Environment } from '@snootsvet/shared/portal'

/**
 * Client-side environment schema. Anything essential is required and will
 * fail the build (or first render) if missing; optional things are marked
 * as such.
 *
 * Vite inlines `import.meta.env.VITE_*` values at build time, so the parse
 * happens against the compiled constants - a missing required var means
 * the app crashes on load, which is the desired fail-fast behaviour.
 *
 * Note: Sentry's initialiser reads `import.meta.env` directly rather than
 * going through this module. It's hoisted at the very top of `main.tsx`
 * so it can catch errors thrown by *this* file's parse step.
 */
const envSchema = z.object({
  VITE_ENVIRONMENT: Environment,
  VITE_STRIPE_PUBLISHABLE_KEY: z.string().min(1, 'VITE_STRIPE_PUBLISHABLE_KEY is required'),
  VITE_API_URL: z.string().url('VITE_API_URL must be a valid URL'),
})

export const env = envSchema.parse(import.meta.env)
